// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_4j-2";
export var blackBorderOnHover = "_4j-7";
export var cell = "_4j-6";
export var cellContainer = "_4j-3";
export var checked = "_4j-8";
export var disabled = "_4j-5";
export var featuredIconCellContainer = "_4j-9";
export var featuredIconTextContainer = "_4j-b";
export var featuredIconWrapper = "_4j-a";
export var noBorder = "_4j-c";
export var orangeSelectedRow = "_co-3";
export var overflowableText = "_4j-0";
export var overflowableTextContainer = "_4j-1";
export var row = "_4i-0";
export var rowCheckboxCell = "_4j-4";
export var selectableTable = "_co-2";